import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    .summary-title { margin-bottom: 19px; }

    .app-description {
        margin-bottom: 25px;
        line-height: 18px;
        font-family: 'Roboto';
        font-size: 14px;
        font-weight: 600;
        color: rgba(64, 55, 57, 1);
        letter-spacing: 1px;
    }

    .grid-container {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-column-gap: 6px;
        grid-row-gap: 2px;
    }

    .spell-check-content {
        grid-row-start: 2;
        grid-row-end: 4;
        grid-column-start: 2;
        grid-column-end: 3;
    }

    @media screen and (max-width: 767px) {
        .app-description { padding: 0 17px; text-align: justify; font-weight: 300; }

        .grid-container { grid-template-columns: 100%; }
        .spell-check-content {
            grid-row-start: auto;
            grid-row-end: auto;
            grid-column-start: auto;
            grid-column-end: auto;
        }

        .grid-container > *:nth-child(3) { grid-row: 2; }
        .grid-container > *:nth-child(5) { grid-row: 3; }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridDescription/Wrapper.js